import { resolveWastePipelineForVendor } from "./wastePipelineRegistry";

/**
 * Whether a vendor's pipeline may be ingested for an organization. Approval is
 * the `pipelineApproved` flag on the organization's vendor expectation, whether
 * the pair runs the vendor's base pipeline or one built for the organization.
 *
 * - `APPROVED`: the data team approved the pair, so runs may be ingested.
 * - `NOT_REVIEWED`: the pipeline can run for QC, but nobody has approved its
 *   output for this organization, so ingestion is blocked.
 * - `NO_PIPELINE`: nothing runs for this pair; the vendor has no base pipeline
 *   and no pipeline was built for the organization.
 */
export type WastePipelineApprovalStatus = "APPROVED" | "NOT_REVIEWED" | "NO_PIPELINE";

/**
 * User-facing labels, defined once so the Oak grid chips and the CSV export
 * cannot drift apart on wording.
 */
export const WASTE_PIPELINE_APPROVAL_LABELS: Record<WastePipelineApprovalStatus, string> = {
  APPROVED: "Approved",
  NOT_REVIEWED: "Needs approval",
  NO_PIPELINE: "No pipeline",
};

export function resolveWastePipelineApproval(input: {
  vendor: string;
  tenantId: string;
  /** `TenantWasteVendor.pipelineApproved` for the pair; false when no row exists. */
  pipelineApproved: boolean;
}): WastePipelineApprovalStatus {
  if (resolveWastePipelineForVendor(input.vendor, input.tenantId) === undefined) {
    return "NO_PIPELINE";
  }
  return input.pipelineApproved ? "APPROVED" : "NOT_REVIEWED";
}

export function isWastePipelineIngestable(status: WastePipelineApprovalStatus): boolean {
  return status === "APPROVED";
}
